import React, { useState, useCallback } from "react";
import { debounce } from "../utils/debounce";

interface CollectionSearchBarProps {
  onSearch: (query: string) => void;
  isLoading: boolean;
}

export const CollectionSearchBar: React.FC<CollectionSearchBarProps> = ({
  onSearch,
  isLoading,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  // Debounced search for collection
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(
    debounce((query: string) => {
      onSearch(query);
    }, 300),
    [onSearch]
  );

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  const handleClear = () => {
    setSearchTerm("");
    onSearch("");
  };


  return (
    <div className="collection-search-container">
      <form onSubmit={handleSubmit} className="search-form">
        <div className="search-input-container">
          <div className="search-icon">
            <svg
              className="w-5 h-5 text-gray-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>

          <input
            type="text"
            value={searchTerm}
            onChange={handleInputChange}
            placeholder="Search in this collection..."
            className="search-input"
            disabled={isLoading}
          />

          {searchTerm && (
            <button
              type="button"
              onClick={handleClear}
              className="clear-button"
              disabled={isLoading}
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
        </div>
      </form>

      <div className="search-options">
        <div className="search-tips">
          <span className="tips-icon">💡</span>
          <span className="tips-text">
            Auto-searching within this collection
          </span>
        </div>
      </div>
    </div>
  );
};